export const TOP_BAR_HEIGHT = 50
export const TOP_BAR_MOBILE_HEIGHT = 90
export const THICK_TOP_BAR_HEIGHT = 90

export const STICKY_BOTTOM_HEIGHT = 60
